module.exports = __webpack_public_path__ + "static/media/Item_Weapon_M1911_C.e6c1e7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_M1911_C.png
// module id = ./src/assets/item/Weapon/Handgun/Item_Weapon_M1911_C.png
// module chunks = 0